import { Button, CircularProgress } from "@mui/material";

export const LoadingButton = ({
  children,
  loading = false,
  disabled,
  fullWidth,
  ...props
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      disabled={loading || disabled}
      {...props}
      sx={{ ...props.sx }}
    >
      {loading && (
        <CircularProgress
          size={16}
          color="inherit"
          sx={{
            position: "absolute",
          }}
        />
      )}

      <span
        style={{
          opacity: loading ? 0 : 1,
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {children}
      </span>
    </Button>
  );
};
